import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@/app/layout/pipes/translate.pipe';
import { Router } from '@angular/router';
import { Component, inject } from '@angular/core';

@Component({
    standalone: true,
    templateUrl: './logout-callback.component.html',
    imports: [ButtonModule, TranslatePipe]
})
export class LogoutCallbackComponent {
    private router = inject(Router);

    goToHome() {
      this.router.navigate(['/']);
    }
}
